import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, Provider } from '@angular/core';
import { GlobalErrorHandler } from './global-error.handler';
import { SessionIdInterceptor } from './session-id.interceptor';
import { TELEMETRY_CONFIG, TelemetryConfig } from './telemetry.config';

/**
 * Registro de la telemetria frontend en una app:
 *
 *   providers: [...provideTelemetry({ errorsEndpoint: `${environment.baseUrl}/telemetry/errors`, appName: 'app-production' })]
 */
export function provideTelemetry(config: TelemetryConfig): Provider[] {
  return [
    { provide: TELEMETRY_CONFIG, useValue: config },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionIdInterceptor,
      multi: true,
    },
  ];
}
